module.exports = __webpack_public_path__ + "aaff8bb2e97112b2a7a4dd7bd54206c7.jpg";